import { Skeleton } from "@mui/material";
import { Facebookicon, Instagramicon, WhatsappIcon } from "Components";
import "./style.css";

export const AllCardsSkeleton = () => {
  return (
    <div style={{ width: "90%" }}>
      <div className="icon_container_home">
        <a href="http://wa.me/+96171728733" target="_blank">
          <WhatsappIcon className="home_Facebook_hover green" />
        </a>
        <a href="https://www.facebook.com/marketique.online" target="_blank">
          <Facebookicon className="home_Facebook_hover facebookColor" />
        </a>
        <a href="https://www.instagram.com/marketique.online/" target="_blank">
          <Instagramicon className="home_Facebook_hover instagram" />
        </a>
      </div>
      <h1 className="main_header">All Products</h1>
      <div className="flex_r card_list">
        <CardSkeleton />
      </div>
    </div>
  );
};

export const CardImageSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      width={"100%"}
      height={272}
      className="card_image_skeleton"
    />
  );
};

export const CardSkeleton = () => {
  return (
    <>
      {[...Array(20)].map((_, i) => (
        <div className="flex_c card_container" key={i}>
          <div className="card_image">
            <CardImageSkeleton />
          </div>
          <div className="flex_r space_between card_info">
            <h5>
              <Skeleton variant="text" width={100} />
            </h5>
            <p>{/* $<Skeleton variant="text" width={50} /> */}</p>
          </div>
        </div>
      ))}
    </>
  );
};
